export const SUBSCRIPTION_PLAN_STATUS_ACTIVE = 'active';
export const SUBSCRIPTION_PLAN_STATUS_TRIAL = 'trial';
export const SUBSCRIPTION_PLAN_STATUS_CANCEL_PENDING = 'cancel_pending';
export const SUBSCRIPTION_PLAN_STATUS_CANCELLED = 'cancelled';
export const SUBSCRIPTION_PLAN_STATUS_EXPIRED = 'expired';
export const SUBSCRIPTION_PLAN_STATUS_PAST_DUE = 'past_due';

export const SUBSCRIPTION_PLAN_TYPE_EDUCATOR = 'educator';
export const SUBSCRIPTION_PLAN_TYPE_PORTAL = 'portal';

export const SUBSCRIPTION_PLAN_BILLING_CYCLE_MONTHLY = 'monthly';
export const SUBSCRIPTION_PLAN_BILLING_CYCLE_YEARLY = 'yearly';

export const SUBSCRIPTION_PLAN_BILLING_METHOD_NONE = 'null';
export const SUBSCRIPTION_PLAN_BILLING_METHOD_INVOICE = 'invoice';
export const SUBSCRIPTION_PLAN_BILLING_METHOD_BRAINTREE = 'braintree';

export const SUBSCRIPTION_PLAN_ACTION_SUBSCRIBE_EDUCATOR = 'subscribe-educator';
export const SUBSCRIPTION_PLAN_ACTION_UPGRADE_EDUCATOR = 'upgrade-educator';
export const SUBSCRIPTION_PLAN_ACTION_UPDATE_PAYMENT_METHOD =
  'update-payment-method';
export const SUBSCRIPTION_PLAN_ACTION_CANCEL = 'cancel';
export const SUBSCRIPTION_PLAN_ACTION_CANCEL_EDUCATOR = 'cancel-educator';
export const SUBSCRIPTION_PLAN_ACTION_SUBSCRIBE_TEACHCOMAU =
  'subscribe-teachcomau';
